<template>
  <div class="mb-3 mt-3 main-container">
    <b-container>
      <b-row>
        <b-col v-if="showError" class="col-12 col-md-6 mb-3">
          <b-card>
            <p v-if="showError === 'save'" class="text-center">{{ $t('apiary.form.error') }}</p>
            <p v-if="showError === 'not found'" class="text-center">{{ $t('apiary.form.not_found') }}</p>
          </b-card>
        </b-col>
      </b-row>
      <template v-if="!loaded">
        <div class="d-flex justify-content-around flex-row"><b-spinner v-if="!loaded && !showError"></b-spinner></div>
      </template>
      <template v-else>
        <b-row>
          <b-col class="col-12 col-md-12 mb-3 position-relative">
            <b-card>
              <h1 class="text-primary font-weight-bold text-center">{{ apiary.title }}</h1>
              <div class="text-center">
                {{ $t('apiary.form.zipCode.label') }}: {{ apiary.zipCode }}
              </div>
              <div class="action-row">
                <b-link class="text-body icon-pen" :title="$t('apiary_edit.title')" @click.prevent="checkNetworkUpdate"></b-link>
              </div>
              <div class="action-row-delete">
                <apiary-delete :id="id"></apiary-delete>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <section>
          <h2 class="text-primary font-weight-bold text-center">{{ $t('apiary.colonies') }}</h2>
          <div class="d-flex justify-content-around flex-row"><b-spinner v-if="!loaded && !showError"></b-spinner></div>
          <b-col class="col-12 col-md-12 mb-3 position-relative">
            <b-link class="text-body" :title="$t('colony_create.title')" @click.prevent="checkNetworkCreate">
              <b-card class="new h-100">
                <div class="h-100 d-flex flex-column justify-content-around colony-list">
                  <h2 class="text-center mb-0">
                    {{ $t('colony_create.title') }}
                    <span class="icon-add_filled align-middle" aria-hidden="true"></span>
                  </h2>
                </div>
              </b-card>
            </b-link>
          </b-col>
          <colony-list :id="id"></colony-list>
        </section>
        <b-modal :id="'offLineModal'" centered hide-header-close @ok="hideModal">
          <template slot="modal-title">
            {{ $t('offLineModal.title') }}
          </template>
          {{ $t('offLineModal.text') }}
          <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
            <b-button size="lg" class="mt-3" @click="ok()">
              {{ $t('offLineModal.ok') }}
            </b-button>
          </template>
        </b-modal>
      </template>
    </b-container>
  </div>
</template>

<script>
import ColonyList from '../components/ColonyList'
import ApiaryDelete from '../components/ApiaryDelete'
export default {
  name: 'Apiary',
  components: { ColonyList, ApiaryDelete },
  props: ['id'],
  data () {
    return {
      showError: false,
      loaded: false,
      apiary: {
        title: null,
        zipCode: null
      }
    }
  },
  methods: {
    checkNetworkUpdate () {
      if (navigator.onLine) {
        this.$router.replace('/apiary/edit/' + this.id)
      } else {
        this.showOffLineModal()
      }
    },
    checkNetworkCreate () {
      if (navigator.onLine) {
        this.$router.replace('/colony/create/' + this.id)
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModal')
    },
    hideModal () {
      this.$bvModal.hide('offLineModal')
    }
  },
  async mounted () {
    if (this.id) {
      try {
        const result = await this.$api.apiaries.getOne(this.id)
        const data = Object.values(result.data.result)
        if (data[0]) {
          this.apiary.title = data[0].title
          this.apiary.zipCode = data[0].field_zip
          this.loaded = true
        } else {
          this.showError = 'not found'
        }
      } catch (e) {
        this.showError = 'not found'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';
  .main-container {
    font-family: "Roboto Condensed", sans-serif;
  }
  h1 {
    .icon-pen {
      font-size: 1.5rem;
    }
  }
  .action-row {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.5rem;
    line-height: 1rem;

    > * {
      display: inline-block;
      padding: 0.5rem 0.75rem;

      &:hover {
        text-decoration: none;
        background-color: $secondary-light;
      }
    }
  }
  .action-row-delete {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 1.5rem;
    line-height: 1rem;

    > * {
      display: inline-block;
      padding: 0.5rem 0.75rem;

      &:hover {
        text-decoration: none;
        background-color: $secondary-light;
      }
    }
  }
  .new {
    background-color: $secondary-light;
    font-family: "Roboto Condensed", sans-serif;
  }
  .card-body {
    padding: 1.25rem;
  }
  .card-body h1{
    font-size: 2rem;
    font-family: $font-family-base;
  }
  .colony-list h2 {
    font-size: 1.5rem;
  }
</style>
